/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mw_col_mass = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mass`)
};

const es_mw_col_mass = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masa`)
};

const de_mw_col_mass = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masse`)
};

const nl_mw_col_mass = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Massa`)
};

const fr_mw_col_mass = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masse`)
};

const it_mw_col_mass = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Massa`)
};

const pt_br2_mw_col_mass = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Massa`)
};

const pt_mw_col_mass = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Massa`)
};

const ja_mw_col_mass = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`質量`)
};

const zh_mw_col_mass = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`质量`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mw_col_mass = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mw_col_mass(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mw_col_mass", locale)
	if (locale === "en") return en_mw_col_mass(inputs)
	if (locale === "es") return es_mw_col_mass(inputs)
	if (locale === "de") return de_mw_col_mass(inputs)
	if (locale === "nl") return nl_mw_col_mass(inputs)
	if (locale === "fr") return fr_mw_col_mass(inputs)
	if (locale === "it") return it_mw_col_mass(inputs)
	if (locale === "pt-BR") return pt_br2_mw_col_mass(inputs)
	if (locale === "pt") return pt_mw_col_mass(inputs)
	if (locale === "ja") return ja_mw_col_mass(inputs)
	return zh_mw_col_mass(inputs)
};